import React, { useEffect, useCallback } from 'react';
import WelcomeScreen from 'js-promo-partners-lib/lib/components/common/welcome-screen/welcome-screen';
import { ROUTES } from '../../services/plugin-service/constants';
import PluginAccountService from '../../services/plugin-service/plugin-account-service';
import getConfig from '../../config';
import httpClient from '../../services/http-client/http-client';
import WithApp from '../hoc/with-app/with-app';

import './app-customer-login-page.scss';

const { nonce, configUrl, loginUrl } = getConfig();

httpClient.setNonce(undefined, nonce);

const service = new PluginAccountService(configUrl, httpClient);

const AppCustomerLoginPage = () => {
    const redirectToSettingsPage = useCallback(() => {
        window.location.href = `admin.php?page=${ROUTES.SETTINGS.route}`;
    }, [ROUTES]);

    const toggleSettingsPage = useCallback(() => {
        window.open(loginUrl);
        redirectToSettingsPage();
    }, []);

    useEffect(async () => {
        const { customerKey, customerSecret } = await service.getCustomerKeys();
        if (customerKey && customerSecret) {
            redirectToSettingsPage();
        }
    }, []);

    return (
        <WelcomeScreen
            className='app-customer-login-page'
            title='Make professional videos in minutes!'
            description='Increase your engagement and conversion with powerful videos.'
            buttonText='Login'
            onSelect={toggleSettingsPage}
        />
    );
};

export default WithApp(AppCustomerLoginPage);
